export default __webpack_public_path__ + "static/media/roundDownload.f03429f6.svg";